import { selectApp, setDrawer } from "@redux";
import { Drawer } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { ComponentSidebar } from "./Sidebar";
import styled from "styled-components";

export const MobileSidebar = () => {
  const dispatch = useDispatch();
  const { drawer } = useSelector(selectApp);
  const handleDrawer = async () => await dispatch(setDrawer(!drawer));
  return (
    <StyledDrawer
      title={null}
      placement={"left"}
      closable={false}
      width={338}
      onClose={handleDrawer}
      open={drawer}
      key={"left"}
    >
      <ComponentSidebar />
    </StyledDrawer>
  );
};

const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 0;
  }
`;
